import { useAuthStore } from '../store/authStore';

/**
 * Custom hook for accessing authentication state and methods
 * Provides a React-friendly interface to the auth store
 * 
 * @returns Auth state and methods
 * 
 * @example
 * const { user, isAuthenticated, login, logout } = useAuth();
 * 
 * if (!isAuthenticated) {
 *   return <LoginForm onSubmit={login} />;
 * }
 */
export const useAuth = () => {
  const token = useAuthStore((state) => state.token);
  const user = useAuthStore((state) => state.user);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const login = useAuthStore((state) => state.login);
  const logout = useAuthStore((state) => state.logout);
  const checkAuth = useAuthStore((state) => state.checkAuth);
  const storeIntendedDestination = useAuthStore((state) => state.storeIntendedDestination);
  const getAndClearIntendedDestination = useAuthStore((state) => state.getAndClearIntendedDestination);

  return {
    token,
    user,
    isAuthenticated,
    login,
    logout,
    checkAuth,
    storeIntendedDestination,
    getAndClearIntendedDestination,
  };
};
